const BENEFITS_COLOR_SET_CLASSES = {
    cashback: {
        default: {
            background: ['bg-benefits-cashback-background-default', 'dark:bg-benefits-cashback-background-default-dark'],
            content: ['text-benefits-cashback-content-default', 'dark:text-benefits-cashback-content-default-dark'],
            icon: [
                'svg-children:stroke-benefits-cashback-content-default',
                'svg-children:fill-benefits-cashback-content-default',
                'dark:svg-children:stroke-benefits-cashback-content-default-dark',
                'dark:svg-children:fill-benefits-cashback-content-default-dark',
            ],
            border: [
                'border-benefits-cashback-background-selected',
                'dark:border-benefits-cashback-background-selected-dark',
            ],
        },
        inverted: {
            background: ['bg-benefits-cashback-content-default', 'dark:bg-benefits-cashback-content-default-dark'],
            content: ['text-benefits-cashback-background-default', 'dark:text-benefits-cashback-background-default-dark'],
            icon: [
                'svg-children:stroke-benefits-cashback-background-default',
                'svg-children:fill-benefits-cashback-background-default',
                'dark:svg-children:stroke-benefits-cashback-background-default-dark',
                'dark:svg-children:fill-benefits-cashback-background-default-dark',
            ],
            border: ['border-content-default/[.06]', 'dark:border-content-default-dark/[.06]'],
        },
    },
    mealVoucher: {
        default: {
            background: [
                'bg-benefits-meal-voucher-background-default',
                'dark:bg-benefits-meal-voucher-background-default-dark',
            ],
            content: ['text-benefits-meal-voucher-content-default', 'dark:text-benefits-meal-voucher-content-default-dark'],
            icon: [
                'svg-children:stroke-benefits-meal-voucher-content-default',
                'svg-children:fill-benefits-meal-voucher-content-default',
                'dark:svg-children:stroke-benefits-meal-voucher-content-default-dark',
                'dark:svg-children:fill-benefits-meal-voucher-content-default-dark',
            ],
            border: [
                'border-benefits-meal-voucher-background-selected',
                'dark:border-benefits-meal-voucher-background-selected-dark',
            ],
        },
        inverted: {
            background: ['bg-benefits-meal-voucher-content-default', 'dark:bg-benefits-meal-voucher-content-default-dark'],
            content: [
                'text-benefits-meal-voucher-background-default',
                'dark:text-benefits-meal-voucher-background-default-dark',
            ],
            icon: [
                'svg-children:stroke-benefits-meal-voucher-background-default',
                'svg-children:fill-benefits-meal-voucher-background-default',
                'dark:svg-children:stroke-benefits-meal-voucher-background-default-dark',
                'dark:svg-children:fill-benefits-meal-voucher-background-default-dark',
            ],
            border: ['border-content-default/[.06]', 'dark:border-content-default-dark/[.06]'],
        },
    },
    mobility: {
        default: {
            background: ['bg-benefits-mobility-background-default', 'dark:bg-benefits-mobility-background-default-dark'],
            content: ['text-benefits-mobility-content-default', 'dark:text-benefits-mobility-content-default-dark'],
            icon: [
                'svg-children:stroke-benefits-mobility-content-default',
                'svg-children:fill-benefits-mobility-content-default',
                'dark:svg-children:stroke-benefits-mobility-content-default-dark',
                'dark:svg-children:fill-benefits-mobility-content-default-dark',
            ],
            border: [
                'border-benefits-mobility-background-selected',
                'dark:border-benefits-mobility-background-selected-dark',
            ],
        },
        inverted: {
            background: ['bg-benefits-mobility-content-default', 'dark:bg-benefits-mobility-content-default-dark'],
            content: ['text-benefits-mobility-background-default', 'dark:text-benefits-mobility-background-default-dark'],
            icon: [
                'svg-children:stroke-benefits-mobility-background-default',
                'svg-children:fill-benefits-mobility-background-default',
                'dark:svg-children:stroke-benefits-mobility-background-default-dark',
                'dark:svg-children:fill-benefits-mobility-background-default-dark',
            ],
            border: ['border-content-default/[.06]', 'dark:border-content-default-dark/[.06]'],
        },
    },
    personalWallet: {
        default: {
            background: [
                'bg-benefits-personal-wallet-background-default',
                'dark:bg-benefits-personal-wallet-background-default-dark',
            ],
            content: [
                'text-benefits-personal-wallet-content-default',
                'dark:text-benefits-personal-wallet-content-default-dark',
            ],
            icon: [
                'svg-children:stroke-benefits-personal-wallet-content-default',
                'svg-children:fill-benefits-personal-wallet-content-default',
                'dark:svg-children:stroke-benefits-personal-wallet-content-default-dark',
                'dark:svg-children:fill-benefits-personal-wallet-content-default-dark',
            ],
            border: [
                'border-benefits-personal-wallet-background-selected',
                'dark:border-benefits-personal-wallet-background-selected-dark',
            ],
        },
        inverted: {
            background: [
                'bg-benefits-personal-wallet-content-default',
                'dark:bg-benefits-personal-wallet-content-default-dark',
            ],
            content: [
                'text-benefits-personal-wallet-background-default',
                'dark:text-benefits-personal-wallet-background-default-dark',
            ],
            icon: [
                'svg-children:stroke-benefits-personal-wallet-background-default',
                'svg-children:fill-benefits-personal-wallet-background-default',
                'dark:svg-children:stroke-benefits-personal-wallet-background-default-dark',
                'dark:svg-children:fill-benefits-personal-wallet-background-default-dark',
            ],
            border: ['border-content-default/[.06]', 'dark:border-content-default-dark/[.06]'],
        },
    },
    gift: {
        default: {
            background: ['bg-benefits-gift-background-default', 'dark:bg-benefits-gift-background-default-dark'],
            content: ['text-benefits-gift-content-default', 'dark:text-benefits-gift-content-default-dark'],
            icon: [
                'svg-children:stroke-benefits-gift-content-default',
                'svg-children:fill-benefits-gift-content-default',
                'dark:svg-children:stroke-benefits-gift-content-default-dark',
                'dark:svg-children:fill-benefits-gift-content-default-dark',
            ],
            border: ['border-benefits-gift-background-selected', 'dark:border-benefits-gift-background-selected-dark'],
        },
        inverted: {
            background: ['bg-benefits-gift-content-default', 'dark:bg-benefits-gift-content-default-dark'],
            content: ['text-benefits-gift-background-default', 'dark:text-benefits-gift-background-default-dark'],
            icon: [
                'svg-children:stroke-benefits-gift-background-default',
                'svg-children:fill-benefits-gift-background-default',
                'dark:svg-children:stroke-benefits-gift-background-default-dark',
                'dark:svg-children:fill-benefits-gift-background-default-dark',
            ],
            border: ['border-content-default/[.06]', 'dark:border-content-default-dark/[.06]'],
        },
    },
};
const FEATURE_COLOR_SET_CLASSES = {
    activity: {
        default: {
            background: ['bg-social-activity-background-default', 'dark:bg-social-activity-background-default-dark'],
            content: ['text-social-activity-content-default', 'dark:text-social-activity-content-default-dark'],
            icon: [
                'svg-children:stroke-social-activity-content-default',
                'svg-children:fill-social-activity-content-default',
                'dark:svg-children:stroke-social-activity-content-default-dark',
                'dark:svg-children:fill-social-activity-content-default-dark',
            ],
            border: ['border-social-activity-background-selected', 'dark:border-social-activity-background-selected-dark'],
        },
        inverted: {
            background: ['bg-social-activity-content-default', 'dark:bg-social-activity-content-default-dark'],
            content: ['text-social-activity-background-default', 'dark:text-social-activity-background-default-dark'],
            icon: [
                'svg-children:stroke-social-activity-background-default',
                'svg-children:fill-social-activity-background-default',
                'dark:svg-children:stroke-social-activity-background-default-dark',
                'dark:svg-children:fill-social-activity-background-default-dark',
            ],
            border: ['border-content-default/[.06]', 'dark:border-content-default-dark/[.06]'],
        },
    },
    article: {
        default: {
            background: ['bg-social-article-background-default', 'dark:bg-social-article-background-default-dark'],
            content: ['text-social-article-content-default', 'dark:text-social-article-content-default-dark'],
            icon: [
                'svg-children:stroke-social-article-content-default',
                'svg-children:fill-social-article-content-default',
                'dark:svg-children:stroke-social-article-content-default-dark',
                'dark:svg-children:fill-social-article-content-default-dark',
            ],
            border: ['border-social-article-background-selected', 'dark:border-social-article-background-selected-dark'],
        },
        inverted: {
            background: ['bg-social-article-content-default', 'dark:bg-social-article-content-default-dark'],
            content: ['text-social-article-background-default', 'dark:text-social-article-background-default-dark'],
            icon: [
                'svg-children:stroke-social-article-background-default',
                'svg-children:fill-social-article-background-default',
                'dark:svg-children:stroke-social-article-background-default-dark',
                'dark:svg-children:fill-social-article-background-default-dark',
            ],
            border: ['border-content-default/[.06]', 'dark:border-content-default-dark/[.06]'],
        },
    },
    pot: {
        default: {
            background: ['bg-social-pot-background-default', 'dark:bg-social-pot-background-default-dark'],
            content: ['text-social-pot-content-default', 'dark:text-social-pot-content-default-dark'],
            icon: [
                'svg-children:stroke-social-pot-content-default',
                'svg-children:fill-social-pot-content-default',
                'dark:svg-children:stroke-social-pot-content-default-dark',
                'dark:svg-children:fill-social-pot-content-default-dark',
            ],
            border: ['border-social-pot-background-selected', 'dark:border-social-pot-background-selected-dark'],
        },
        inverted: {
            background: ['bg-social-pot-content-default', 'dark:bg-social-pot-content-default-dark'],
            content: ['text-social-pot-background-default', 'dark:text-social-pot-background-default-dark'],
            icon: [
                'svg-children:stroke-social-pot-background-default',
                'svg-children:fill-social-pot-background-default',
                'dark:svg-children:stroke-social-pot-background-default-dark',
                'dark:svg-children:fill-social-pot-background-default-dark',
            ],
            border: ['border-content-default/[.06]', 'dark:border-content-default-dark/[.06]'],
        },
    },
    praise: {
        default: {
            background: [
                'bg-social-praise-default-background-default',
                'dark:bg-social-praise-default-background-default-dark',
            ],
            content: ['text-social-praise-default-content-default', 'dark:text-social-praise-default-content-default-dark'],
            icon: [
                'svg-children:stroke-social-praise-default-content-default',
                'svg-children:fill-social-praise-default-content-default',
                'dark:svg-children:stroke-social-praise-default-content-default-dark',
                'dark:svg-children:fill-social-praise-default-content-default-dark',
            ],
            border: [
                'border-social-praise-default-background-selected',
                'dark:border-social-praise-default-background-selected-dark',
            ],
        },
        inverted: {
            background: ['bg-social-praise-default-content-default', 'dark:bg-social-praise-default-content-default-dark'],
            content: [
                'text-social-praise-default-background-default',
                'dark:text-social-praise-default-background-default-dark',
            ],
            icon: [
                'svg-children:stroke-social-praise-default-background-default',
                'svg-children:fill-social-praise-default-background-default',
                'dark:svg-children:stroke-social-praise-default-background-default-dark',
                'dark:svg-children:fill-social-praise-default-background-default-dark',
            ],
            border: ['border-content-default/[.06]', 'dark:border-content-default-dark/[.06]'],
        },
    },
    pulse: {
        default: {
            background: ['bg-social-pulse-background-default', 'dark:bg-social-pulse-background-default-dark'],
            content: ['text-social-pulse-content-default', 'dark:text-social-pulse-content-default-dark'],
            icon: [
                'svg-children:stroke-social-pulse-content-default',
                'svg-children:fill-social-pulse-content-default',
                'dark:svg-children:stroke-social-pulse-content-default-dark',
                'dark:svg-children:fill-social-pulse-content-default-dark',
            ],
            border: ['border-social-pulse-background-selected', 'dark:border-social-pulse-background-selected-dark'],
        },
        inverted: {
            background: ['bg-social-pulse-content-default', 'dark:bg-social-pulse-content-default-dark'],
            content: ['text-social-pulse-background-default', 'dark:text-social-pulse-background-default-dark'],
            icon: [
                'svg-children:stroke-social-pulse-background-default',
                'svg-children:fill-social-pulse-background-default',
                'dark:svg-children:stroke-social-pulse-background-default-dark',
                'dark:svg-children:fill-social-pulse-background-default-dark',
            ],
            border: ['border-content-default/[.06]', 'dark:border-content-default-dark/[.06]'],
        },
    },
};
const CORE_COLOR_SET_CLASSES = {
    critical: {
        default: {
            background: ['bg-background-critical', 'dark:bg-background-critical-dark'],
            content: ['text-content-accent-critical', 'dark:text-content-accent-critical-dark'],
            icon: [
                'svg-children:stroke-content-accent-critical',
                'svg-children:fill-content-accent-critical',
                'dark:svg-children:stroke-content-accent-critical-dark',
                'dark:svg-children:fill-content-accent-critical-dark',
            ],
            border: ['border-border-critical', 'dark:border-border-critical-dark'],
        },
        inverted: {
            background: ['bg-content-critical', 'dark:bg-content-critical-dark'],
            content: ['text-background-critical', 'dark:text-background-critical-dark'],
            icon: [
                'svg-children:stroke-background-critical',
                'svg-children:fill-background-critical',
                'dark:svg-children:stroke-background-critical-dark',
                'dark:svg-children:fill-background-critical-dark',
            ],
            border: ['border-content-default/[0.06]'],
        },
    },
    success: {
        default: {
            background: ['bg-background-success', 'dark:bg-background-success-dark'],
            content: ['text-content-accent-success', 'dark:text-content-accent-success-dark'],
            icon: [
                'svg-children:stroke-content-accent-success',
                'svg-children:fill-content-accent-success',
                'dark:svg-children:stroke-content-accent-success-dark',
                'dark:svg-children:fill-content-accent-success-dark',
            ],
            border: ['border-border-success', 'dark:border-border-success-dark'],
        },
        inverted: {
            background: ['bg-content-success', 'dark:bg-content-success-dark'],
            content: ['text-background-success', 'dark:text-background-success-dark'],
            icon: [
                'svg-children:stroke-background-success',
                'svg-children:fill-background-success',
                'dark:svg-children:stroke-background-success-dark',
                'dark:svg-children:fill-background-success-dark',
            ],
            border: ['border-content-default/[.06]', 'dark:border-content-default-dark/[.06]'],
        },
    },
    warning: {
        default: {
            background: ['bg-background-warning', 'dark:bg-background-warning-dark'],
            content: ['text-content-accent-warning', 'dark:text-content-accent-warning-dark'],
            icon: [
                'svg-children:stroke-content-accent-warning',
                'svg-children:fill-content-accent-warning',
                'dark:svg-children:stroke-content-accent-warning-dark',
                'dark:svg-children:fill-content-accent-warning-dark',
            ],
            border: ['border-border-warning', 'dark:border-border-warning-dark'],
        },
        inverted: {
            background: ['bg-content-warning', 'dark:bg-content-warning-dark'],
            content: ['text-background-warning', 'dark:text-background-warning-dark'],
            icon: [
                'svg-children:stroke-background-warning',
                'svg-children:fill-background-warning',
                'dark:svg-children:stroke-background-warning-dark',
                'dark:svg-children:fill-background-warning-dark',
            ],
            border: ['border-content-default/[.06]', 'dark:border-content-default-dark/[.06]'],
        },
    },
    contrast: {
        default: {
            background: ['bg-background-contrast', 'dark:bg-background-contrast-dark'],
            content: ['text-content-above-contrast', 'dark:text-content-above-contrast-dark'],
            icon: [
                'svg-children:stroke-content-above-contrast',
                'svg-children:fill-content-above-contrast',
                'dark:svg-children:stroke-content-above-contrast-dark',
                'dark:svg-children:fill-content-above-contrast-dark',
            ],
            border: ['border-border-contrast', 'dark:border-border-contrast-dark'],
        },
        inverted: {
            background: ['bg-content-above-contrast', 'dark:bg-content-above-contrast-dark'],
            content: ['text-background-contrast', 'dark:text-background-contrast-dark'],
            icon: [
                'svg-children:stroke-background-contrast',
                'svg-children:fill-background-contrast',
                'dark:svg-children:stroke-background-contrast-dark',
                'dark:svg-children:fill-background-contrast-dark',
            ],
            border: ['border-content-default/[.06]', 'dark:border-content-default-dark/[.06]'],
        },
    },
    primary: {
        default: {
            background: ['bg-background-primary', 'dark:bg-background-primary-dark'],
            content: ['text-content-primary', 'dark:text-content-primary-dark'],
            icon: [
                'svg-children:stroke-content-primary',
                'svg-children:fill-content-primary',
                'dark:svg-children:stroke-content-primary-dark',
                'dark:svg-children:fill-content-primary-dark',
            ],
            border: ['border-border-primary', 'dark:border-border-primary-dark'],
        },
        inverted: {
            background: ['bg-content-primary', 'dark:bg-content-primary-dark'],
            content: ['text-background-primary', 'dark:text-background-primary-dark'],
            icon: [
                'svg-children:stroke-background-primary',
                'svg-children:fill-background-primary',
                'dark:svg-children:stroke-background-primary-dark',
                'dark:svg-children:fill-background-primary-dark',
            ],
            border: ['border-content-default/[.06]', 'dark:border-content-default-dark/[.06]'],
        },
    },
    default: {
        default: {
            content: ['text-content-default', 'dark:text-content-default-dark'],
            background: ['bg-background-default', 'dark:bg-background-default-dark'],
            icon: [
                'svg-children:stroke-content-default',
                'svg-children:fill-content-default',
                'dark:svg-children:stroke-content-default-dark',
                'dark:svg-children:fill-content-default-dark',
            ],
            border: ['border-border-default', 'dark:border-border-default-dark'],
        },
        inverted: {
            background: ['bg-content-default', 'dark:bg-content-default-dark'],
            content: ['text-background-default', 'dark:text-background-default-dark'],
            icon: [
                'svg-children:stroke-background-default',
                'svg-children:fill-background-default',
                'dark:svg-children:stroke-background-default-dark',
                'dark:svg-children:fill-background-default-dark',
            ],
            border: ['border-content-default/[.06]', 'dark:border-content-default-dark/[.06]'],
        },
    },
};
const INTERACTIVE_CLASSES = {
    'interactive.primary': {
        background: ['bg-interactive-primary-default', 'dark:bg-interactive-primary-default-dark'],
        icon: [
            'svg-children:stroke-content-above-primary',
            'svg-children:fill-content-above-primary',
            'dark:svg-children:stroke-content-above-primary-dark',
            'dark:svg-children:fill-content-above-primary-dark',
        ],
        content: ['text-content-above-primary', 'dark:text-content-above-primary-dark'],
        border: ['border-interactive-primary-pressed', 'dark:border-interactive-primary-pressed-dark'],
    },
    'interactive.primary.hover': {
        background: ['bg-interactive-primary-hover', 'dark:bg-interactive-primary-hover-dark'],
        icon: [
            'svg-children:stroke-content-above-primary',
            'svg-children:fill-content-above-primary',
            'dark:svg-children:stroke-content-above-primary-dark',
            'dark:svg-children:fill-content-above-primary-dark',
        ],
        content: ['text-content-above-primary', 'dark:text-content-above-primary-dark'],
        border: ['border-interactive-primary-pressed', 'dark:border-interactive-primary-pressed-dark'],
    },
    'interactive.primary.pressed': {
        background: ['bg-interactive-primary-pressed', 'dark:bg-interactive-primary-pressed-dark'],
        icon: [
            'svg-children:stroke-content-above-primary',
            'svg-children:fill-content-above-primary',
            'dark:svg-children:stroke-content-above-primary-dark',
            'dark:svg-children:fill-content-above-primary-dark',
        ],
        content: ['text-content-above-primary', 'dark:text-content-above-primary-dark'],
        border: ['border-interactive-primary-pressed', 'dark:border-interactive-primary-pressed-dark'],
    },
    'interactive.primary.disabled': {
        background: ['bg-interactive-disabled', 'dark:bg-interactive-disabled-dark'],
        content: ['text-content-disabled', 'dark:text-content-disabled-dark'],
        icon: [
            'svg-children:stroke-content-disabled',
            'svg-children:fill-content-disabled',
            'dark:svg-children:stroke-content-disabled-dark',
            'dark:svg-children:fill-content-disabled-dark',
        ],
        border: ['border-interactive-primary-pressed', 'dark:border-interactive-primary-pressed-dark'],
    },
    'interactive.secondary': {
        background: ['bg-interactive-secondary-default', 'dark:bg-interactive-secondary-default-dark'],
        icon: [
            'svg-children:stroke-content-above-secondary',
            'svg-children:fill-content-above-secondary',
            'dark:svg-children:stroke-content-above-secondary-dark',
            'dark:svg-children:fill-content-above-secondary-dark',
        ],
        content: ['text-content-above-secondary', 'dark:text-content-above-secondary-dark'],
        border: ['border-interactive-secondary-pressed', 'dark:border-interactive-secondary-pressed-dark'],
    },
    'interactive.secondary.hover': {
        background: ['bg-interactive-secondary-hover', 'dark:bg-interactive-secondary-hover-dark'],
        icon: [
            'svg-children:stroke-content-above-secondary',
            'svg-children:fill-content-above-secondary',
            'dark:svg-children:stroke-content-above-secondary-dark',
            'dark:svg-children:fill-content-above-secondary-dark',
        ],
        content: ['text-content-above-secondary', 'dark:text-content-above-secondary-dark'],
        border: ['border-interactive-secondary-pressed', 'dark:border-interactive-secondary-pressed-dark'],
    },
    'interactive.secondary.pressed': {
        background: ['bg-interactive-secondary-pressed', 'dark:bg-interactive-secondary-pressed-dark'],
        icon: [
            'svg-children:stroke-content-above-secondary',
            'svg-children:fill-content-above-secondary',
            'dark:svg-children:stroke-content-above-secondary-dark',
            'dark:svg-children:fill-content-above-secondary-dark',
        ],
        content: ['text-content-above-secondary', 'dark:text-content-above-secondary-dark'],
        border: ['border-interactive-secondary-pressed', 'dark:border-interactive-secondary-pressed-dark'],
    },
    'interactive.secondary.disabled': {
        background: ['bg-background-contrast', 'dark:bg-background-contrast-dark'],
        content: ['text-content-disabled', 'dark:text-content-disabled-dark'],
        icon: [
            'svg-children:stroke-content-disabled',
            'svg-children:fill-content-disabled',
            'dark:svg-children:stroke-content-disabled-dark',
            'dark:svg-children:fill-content-disabled-dark',
        ],
        border: ['border-interactive-secondary-pressed', 'dark:border-interactive-secondary-pressed-dark'],
    },
    'interactive.text': {
        content: ['text-content-above-text', 'dark:text-content-above-text-dark'],
        background: ['bg-interactive-text-default', 'dark:bg-interactive-text-default-dark'],
        icon: [
            'svg-children:stroke-content-above-text',
            'svg-children:fill-content-above-text',
            'dark:svg-children:stroke-content-above-text-dark',
            'dark:svg-children:fill-content-above-text-dark',
        ],
        border: ['border-interactive-text-pressed', 'dark:border-interactive-text-pressed-dark'],
    },
    'interactive.text.hover': {
        background: ['bg-interactive-text-hover', 'dark:bg-interactive-text-hover-dark'],
        content: ['text-content-above-text', 'dark:text-content-above-text-dark'],
        icon: [
            'svg-children:stroke-content-above-text',
            'svg-children:fill-content-above-text',
            'dark:svg-children:stroke-content-above-text-dark',
            'dark:svg-children:fill-content-above-text-dark',
        ],
        border: ['border-interactive-text-pressed', 'dark:border-interactive-text-pressed-dark'],
    },
    'interactive.text.pressed': {
        background: ['bg-interactive-text-pressed', 'dark:bg-interactive-text-pressed-dark'],
        content: ['text-content-above-text', 'dark:text-content-above-text-dark'],
        icon: [
            'svg-children:stroke-content-above-text',
            'svg-children:fill-content-above-text',
            'dark:svg-children:stroke-content-above-text-dark',
            'dark:svg-children:fill-content-above-text-dark',
        ],
        border: ['border-interactive-text-pressed', 'dark:border-interactive-text-pressed-dark'],
    },
    'interactive.text.disabled': {
        background: ['bg-background-contrast', 'dark:bg-background-contrast-dark'],
        content: ['text-content-disabled', 'dark:text-content-disabled-dark'],
        icon: [
            'svg-children:stroke-content-disabled',
            'svg-children:fill-content-disabled',
            'dark:svg-children:stroke-content-disabled-dark',
            'dark:svg-children:fill-content-disabled-dark',
        ],
        border: ['border-interactive-text-pressed', 'dark:border-interactive-text-pressed-dark'],
    },
    'interactive.critical': {
        background: ['bg-interactive-critical-default', 'dark:bg-interactive-critical-default-dark'],
        icon: [
            'svg-children:stroke-content-above-critical',
            'svg-children:fill-content-above-critical',
            'dark:svg-children:stroke-content-above-critical-dark',
            'dark:svg-children:fill-content-above-critical-dark',
        ],
        content: ['text-content-above-critical', 'dark:text-content-above-critical-dark'],
        border: ['border-interactive-critical-pressed', 'dark:border-interactive-critical-pressed-dark'],
    },
    'interactive.critical.hover': {
        background: ['bg-interactive-critical-hover', 'dark:bg-interactive-critical-hover-dark'],
        icon: [
            'svg-children:stroke-content-above-critical',
            'svg-children:fill-content-above-critical',
            'dark:svg-children:stroke-content-above-critical-dark',
            'dark:svg-children:fill-content-above-critical-dark',
        ],
        content: ['text-content-above-critical', 'dark:text-content-above-critical-dark'],
        border: ['border-interactive-critical-pressed', 'dark:border-interactive-critical-pressed-dark'],
    },
    'interactive.critical.pressed': {
        background: ['bg-interactive-critical-pressed', 'dark:bg-interactive-critical-pressed-dark'],
        icon: [
            'svg-children:stroke-content-above-critical',
            'svg-children:fill-content-above-critical',
            'dark:svg-children:stroke-content-above-critical-dark',
            'dark:svg-children:fill-content-above-critical-dark',
        ],
        content: ['text-content-above-critical', 'dark:text-content-above-critical-dark'],
        border: ['border-interactive-critical-pressed', 'dark:border-interactive-critical-pressed-dark'],
    },
    'interactive.critical.disabled': {
        background: ['bg-background-contrast', 'dark:bg-background-contrast-dark'],
        content: ['text-content-disabled', 'dark:text-content-disabled-dark'],
        icon: [
            'svg-children:stroke-content-disabled',
            'svg-children:fill-content-disabled',
            'dark:svg-children:stroke-content-disabled-dark',
            'dark:svg-children:fill-content-disabled-dark',
        ],
        border: ['border-interactive-critical-pressed', 'dark:border-interactive-critical-pressed-dark'],
    },
    'interactive.contrast': {
        background: ['bg-interactive-contrast-default', 'dark:bg-interactive-contrast-default-dark'],
        icon: [
            'svg-children:stroke-content-above-contrast',
            'svg-children:fill-content-above-contrast',
            'dark:svg-children:stroke-content-above-contrast-dark',
            'dark:svg-children:fill-content-above-contrast-dark',
        ],
        content: ['text-content-above-contrast', 'dark:text-content-above-contrast-dark'],
        border: ['border-interactive-contrast-pressed', 'dark:border-interactive-contrast-pressed-dark'],
    },
    'interactive.contrast.hover': {
        background: ['bg-interactive-contrast-hover', 'dark:bg-interactive-contrast-hover-dark'],
        icon: [
            'svg-children:stroke-content-above-contrast',
            'svg-children:fill-content-above-contrast',
            'dark:svg-children:stroke-content-above-contrast-dark',
            'dark:svg-children:fill-content-above-contrast-dark',
        ],
        content: ['text-content-above-contrast', 'dark:text-content-above-contrast-dark'],
        border: ['border-interactive-contrast-pressed', 'dark:border-interactive-contrast-pressed-dark'],
    },
    'interactive.contrast.pressed': {
        background: ['bg-interactive-contrast-pressed', 'dark:bg-interactive-contrast-pressed-dark'],
        icon: [
            'svg-children:stroke-content-above-contrast',
            'svg-children:fill-content-above-contrast',
            'dark:svg-children:stroke-content-above-contrast-dark',
            'dark:svg-children:fill-content-above-contrast-dark',
        ],
        content: ['text-content-above-contrast', 'dark:text-content-above-contrast-dark'],
        border: ['border-interactive-contrast-pressed', 'dark:border-interactive-contrast-pressed-dark'],
    },
    'interactive.contrast.disabled': {
        background: ['bg-background-contrast', 'dark:bg-background-contrast-dark'],
        content: ['text-content-disabled', 'dark:text-content-disabled-dark'],
        icon: [
            'svg-children:stroke-content-disabled',
            'svg-children:fill-content-disabled',
            'dark:svg-children:stroke-content-disabled-dark',
            'dark:svg-children:fill-content-disabled-dark',
        ],
        border: ['border-interactive-contrast-pressed', 'dark:border-interactive-contrast-pressed-dark'],
    },
};
const INTERACTIVE_COLOR_SET_CLASSES = {
    'interactive.primary': {
        default: INTERACTIVE_CLASSES['interactive.primary'],
        inverted: INTERACTIVE_CLASSES['interactive.primary'],
    },
    'interactive.primary.hover': {
        default: INTERACTIVE_CLASSES['interactive.primary.hover'],
        inverted: INTERACTIVE_CLASSES['interactive.primary.hover'],
    },
    'interactive.primary.pressed': {
        default: INTERACTIVE_CLASSES['interactive.primary.pressed'],
        inverted: INTERACTIVE_CLASSES['interactive.primary.pressed'],
    },
    'interactive.primary.disabled': {
        default: INTERACTIVE_CLASSES['interactive.primary.disabled'],
        inverted: INTERACTIVE_CLASSES['interactive.primary.disabled'],
    },
    'interactive.secondary': {
        default: INTERACTIVE_CLASSES['interactive.secondary'],
        inverted: INTERACTIVE_CLASSES['interactive.secondary'],
    },
    'interactive.secondary.hover': {
        default: INTERACTIVE_CLASSES['interactive.secondary.hover'],
        inverted: INTERACTIVE_CLASSES['interactive.secondary.hover'],
    },
    'interactive.secondary.pressed': {
        default: INTERACTIVE_CLASSES['interactive.secondary.pressed'],
        inverted: INTERACTIVE_CLASSES['interactive.secondary.pressed'],
    },
    'interactive.secondary.disabled': {
        default: INTERACTIVE_CLASSES['interactive.secondary.disabled'],
        inverted: INTERACTIVE_CLASSES['interactive.secondary.disabled'],
    },
    'interactive.text': {
        default: INTERACTIVE_CLASSES['interactive.text'],
        inverted: INTERACTIVE_CLASSES['interactive.text'],
    },
    'interactive.text.hover': {
        default: INTERACTIVE_CLASSES['interactive.text.hover'],
        inverted: INTERACTIVE_CLASSES['interactive.text.hover'],
    },
    'interactive.text.pressed': {
        default: INTERACTIVE_CLASSES['interactive.text.pressed'],
        inverted: INTERACTIVE_CLASSES['interactive.text.pressed'],
    },
    'interactive.text.disabled': {
        default: INTERACTIVE_CLASSES['interactive.text.disabled'],
        inverted: INTERACTIVE_CLASSES['interactive.text.disabled'],
    },
    'interactive.critical': {
        default: INTERACTIVE_CLASSES['interactive.critical'],
        inverted: INTERACTIVE_CLASSES['interactive.critical'],
    },
    'interactive.critical.hover': {
        default: INTERACTIVE_CLASSES['interactive.critical.hover'],
        inverted: INTERACTIVE_CLASSES['interactive.critical.hover'],
    },
    'interactive.critical.pressed': {
        default: INTERACTIVE_CLASSES['interactive.critical.pressed'],
        inverted: INTERACTIVE_CLASSES['interactive.critical.pressed'],
    },
    'interactive.critical.disabled': {
        default: INTERACTIVE_CLASSES['interactive.critical.disabled'],
        inverted: INTERACTIVE_CLASSES['interactive.critical.disabled'],
    },
    'interactive.contrast': {
        default: INTERACTIVE_CLASSES['interactive.contrast'],
        inverted: INTERACTIVE_CLASSES['interactive.contrast'],
    },
    'interactive.contrast.hover': {
        default: INTERACTIVE_CLASSES['interactive.contrast.hover'],
        inverted: INTERACTIVE_CLASSES['interactive.contrast.hover'],
    },
    'interactive.contrast.pressed': {
        default: INTERACTIVE_CLASSES['interactive.contrast.pressed'],
        inverted: INTERACTIVE_CLASSES['interactive.contrast.pressed'],
    },
    'interactive.contrast.disabled': {
        default: INTERACTIVE_CLASSES['interactive.contrast.disabled'],
        inverted: INTERACTIVE_CLASSES['interactive.contrast.disabled'],
    },
};
export const COLOR_SET_CLASSES = Object.assign(Object.assign(Object.assign(Object.assign({}, BENEFITS_COLOR_SET_CLASSES), FEATURE_COLOR_SET_CLASSES), CORE_COLOR_SET_CLASSES), INTERACTIVE_COLOR_SET_CLASSES);
